<template>
    <div v-loading="loading" class="loading" v-if="loading"></div>
    <div class="backpage" @click="goBack">
        <el-icon>
            <Back />
        </el-icon> 返回上一级
    </div>
    <div class="installt">
        <div class="intext">订单详情</div>
    </div>
    <div class="order">
        <div class="orderstatel">
            <div class="orderstate">
                <div class="ordertext">
                    <div class="orderimg">
                        <img src="../../assets/order/order1.png" alt="">
                    </div>
                    <div>{{ orderState(order.order.orderState) }}</div>
                </div>
                <div style="margin-top: 15px;">店铺名: {{ order.productInfo.ucomname }}</div>
                <div class="orderstore" >

                    <div class="orderhead" @click="goodmsg(order.productInfo.pid,order.storeInfo.ucomid)">
                        <div class="orderheads">
                            <img :src="images(order.productInfo.ppreviewpic)" alt="">
                        </div>
                        <div class="ordername">
                            <div class="ordernames" :title="order.productInfo.pname" style=""> {{
        order.productInfo.pname }} </div>
                            <div class="jianjie" style="">
                                {{ order.productSpec }}
                            </div>
                        </div>
                    </div>
                    <div class="ordernuber">
                        <div class="nmber">
                            <div>￥{{ order.order.goodsAmount }}</div>
                            <div class="jianjie">数量: {{ order.productInfo.opQuantity }}</div>
                        </div>
                    </div>
                </div>
                <div class="fahuo">
                    <div class="overandfahuo">
                        <div v-if="order.order.orderState != 40" class="over" @click="complete">标记为已完成 </div>
                        <div v-if="order.order.orderState == 20" class="now" @click="handleClose">现在去发货</div>
                    </div>
                </div>
            </div>
            <div class="orderstated">
                <div class="ordertext">
                    <div class="orderimg">
                        <img src="../../assets/order/order2.png" alt="">
                    </div>
                    <div>{{ orderStates(order.order.orderState) }}</div>
                </div>
                <div class="xiaoji">
                    <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao">小记</div>
                            <div></div>
                        </div>
                        <div>￥{{ order.order.goodsAmount }}</div>
                    </div>
                    <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao">积分</div>
                            <div></div>
                        </div>
                        <div>-￥ {{ order.order.integralMoney }}</div>
                    </div>
                    <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao">优惠券</div>
                            <div></div>
                        </div>
                        <div>-￥ {{ order.order.preferentialMoney }}</div>
                    </div>
                    <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao" style="color: #111827;">总计</div>
                            <div></div>
                        </div>
                        <div>￥{{ order.order.paymentMoney }}</div>
                    </div>
                </div>
                <div class="yifu">
                    <div style="font-size: 18px;color: #718096;">买家已支付</div>
                    <div style="font-size: 22px;color: #111827;">￥{{ order.order.orderAmount }}</div>
                </div>
            </div>
        </div>
        <div class="Buyer">
            <div class="bMessages">
                <div>买家信息</div>
                <div class="maihead">
                    <div class="header">
                        <div class="hea">
                            <img style="width: 100%;height: 100%;" :src="images(order.userAvatar)" alt="">
                        </div>
                        <div class="hname">
                            <div>{{ order.orderInfo.uaName || '未知' }}</div>
                            <div class="memngl">门铃号:{{ order.orderInfo.uid || '未知' }}</div>
                        </div>
                    </div>
                    <div class="tongz">
                        <el-icon color="#409EFC" :size="24">
                            <Message />
                        </el-icon>
                    </div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>

                <div class="hname">
                    <div style="display: flex;justify-content: space-between;">
                        <div>联系信息</div>
                        <div v-if="order.orderInfo.uaTel" @click="copy(order.orderInfo.uaTel)"
                            style="font-size: 14px;color: #718096;cursor: pointer;"><el-icon>
                                <DocumentCopy />
                            </el-icon>&nbsp; 复制</div>
                    </div>
                    <div class="memngl"><el-icon>
                            <Phone />
                        </el-icon> {{ order.orderInfo.uaTel || '未知' }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div style="display: flex;justify-content: space-between;">
                        <div>地址</div>
                        <div v-if="order.orderInfo.address" @click="copy(order.orderInfo.address)"
                            style="font-size: 14px;color: #718096;cursor: pointer;"><el-icon>
                                <DocumentCopy />
                            </el-icon>&nbsp;复制</div>
                    </div>
                    <div class="memngl"><el-icon>
                            <Location />
                        </el-icon> {{ order.orderInfo.address || '暂无' }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
            </div>
            <div class="bian">
                <div class="hname">
                    <div>订单编号：{{ order.orderInfo.osn || '未知' }}</div>
                    <div>下单时间：{{ datahuan(order.orderInfo.ostime) }}</div>
                    <div> 快递单号: {{ order.order.sCode || '暂无' }} </div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div>支付方式：{{ payTypes(order.orderInfo.payType) }}</div>
                    <div>付款时间：{{ datahuan(order.orderInfo.oatime) }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div>备注</div>
                    <div class="memngl"> {{ order.notes ? order.notes : '买家暂无备注' }} </div>
                </div>

            </div>

        </div>

    </div>
    <el-dialog v-model="openfahuonow" title="提示" width="500" :before-close="dialogVisible = false">
        <span>请选择快递公司:</span> &nbsp;


        <el-autocomplete v-model="getDelivery" :fetch-suggestions="querySearch" clearable class="inline-input w-50"
            placeholder="请选择快递公司" @select="handleSelect" /> <br>
        <br>
        <span>请输入快递单号:</span> &nbsp; <el-input v-model="danhao" style="width: 240px" placeholder="请输入快递单号" />
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="openfahuonow = false">取消</el-button>
                <el-button type="primary" @click="kuaidfahuo">
                    确定
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { useStore } from 'vuex'
import { ref } from 'vue'
import stores from '@/api/store';
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';

const store = useStore()
let order = ref(store.state.storeId)
console.log('order', order) // 打印 state 中的 storeId
const router = useRouter()

const openfahuonow = ref(false)
let getDeliveryCompanyList = ref([])
let getDelivery = ref('')
let danhao = ref('')
const goodmsg = (id,ucomid)=>{
    router.push({
        path:"/home/goodlist/description",
        query:{
            pid:id,
            commit:ucomid
        }
    })
}


const handleClose = async () => {
    openfahuonow.value = true
    const res = await stores.getDeliveryCompanyList()
    // getDeliveryCompanyList.value = res.date

    getDeliveryCompanyList.value = Object.entries(res.data).map(([key, value]) => ({ value: value, table: key }));
    console.log('getDeliveryCompanyList', getDeliveryCompanyList.value)

}
const querySearch = (queryString, cb) => {
    console.log(queryString)
    const results = queryString ? createFilter(queryString) : getDeliveryCompanyList.value
    console.log(results)

    cb(results)
}
const createFilter = (queryString) => {
    // let asc = []
    const asc = getDeliveryCompanyList.value.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
let CompanyCode = null
const handleSelect = (item) => {
    console.log(item)
    getDelivery.value = item.value
    CompanyCode = item.table
}
const kuaidfahuo = async () => {
    if (CompanyCode || danhao.value) {
        loading.value = true
        openfahuonow.value = false
        let storeId = order.value.order.storeId
        let orderId = order.value.order.id
        let params = {
            storeId,
            orderId,
            deliveryNumber: danhao.value,
            deliveryType: 10,
            orderType: 1,
            deliveryCompanyCode: CompanyCode
        }
        const res = await stores.delivery(params)
        if (res.success) {
            loading.value = false
            order.order.orderState = 20
            ElMessage({
                message: '发货成功！',
                type: 'success',

            })
        } else {
            loading.value = false
            ElMessage.error(res.message)

        }
    } else {
        ElMessage({
            message: '请完善信息！',
            type: 'warning',

        })
    }



}
const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]
                }
            }
        } else {
            console.log('未找到匹配的字符串');
            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../../assets/shop/morentx.png')
    }

}
const datahuan = (days) => {

    if (days) {
        const timestamp = Date.parse(days);
        const date = new Date(timestamp);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
        console.log(days, formattedDate)

        return formattedDate
    } else {
        return '未知时间'
    }
    // const date = new Date(days)
    // const year = date.getFullYear()
    // const month = date.getMonth() + 1
    // const day = date.getDate()
    // return `${year}-${month}-${day}`

}
const goBack = () => {
    window.history.back();
}
const complete = () => {
    ElMessageBox.confirm(
        '确定完成该订单？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            completes()
        })
        .catch(() => {

        })
}
const completes = async () => {
    let orderId = order.value.order.id
    const res = await stores.complete(orderId, 1)
    console.log(res)
    if (res.success) {
        order.value.order.orderState = 40
        ElMessage({
            message: ' 此订单以修改为完成 ！',
            type: 'success',
        })
    } else {
        ElMessage.error(res.message)

    }
}
let loading = ref(false)

let textarea = ref('')
const copy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    //   document.body.removeChild(textarea);
    ElMessage({
        message: '复制成功',
        type: 'success',
    })
}
const fahuonow = async (values) => {
    console.log(order.value)
    let storeId = order.value.order.storeId
    let orderId = order.value.order.id
    // let deliverNumber = order.value.orderInfo.osn

    const res = await stores.deliver(storeId, orderId, values, 1)
    console.log(res)
    if (res.success) {
        ElMessage({
            message: '发货成功！',
            type: 'success',

        })
        loading.value = false
        order.order.orderState = 20

    } else {
        // console.log(res.message)
        let message = res.message
        ElMessage.error(message)
        loading.value = false

    }
}
const payTypes = (payType) => {
    if (payType == 0) {
        return '华标支付'
    } else if (payType == 1) {
        return '微信支付'
    } else if (payType == 1) {
        return '支付支付'
    } else if (payType == 1) {
        return '门币支付'
    } else if (payType == 1) {
        return '竹子支付'
    } else if (payType == 1) {
        return '新闲钱宝'
    }
}
const orderState = (State) => {
    console.log('State', State)
    if (State == '0') {
        return '已取消'
    } else if (State == '10') {
        return '未付款'
    } else if (State == '20') {
        return '已付款'
    } else if (State == '30') {
        return '已发货'
    } else if (State == '40') {
        return '已收货'
    } else {
        return '未知'
    }
}
const orderStates = (State) => {
    if (State == '10' || State == '0') {
        return '未付款'
    } else if (State == '20' || State == '30' || State == '40') {
        return '已付款'
    } else {
        return '未知'

    }
}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 820px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

}

.order {
    margin-top: 22px;
    height: calc(100% - 84px);
    border-radius: 16px;
    display: flex;

    .orderstatel {
        height: 100%;

        // min-width: 720px;
        width: calc(100% - 396px);

        .orderstate {
            width: 100%;
            height: 347px;
            background-color: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 0 34px;

            .ordertext {
                height: 92px;
                border-bottom: 1px solid #F1F2F4;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-family: AppleSystemUIFont;
                color: #FE964A;

                .orderimg {
                    width: 34px;
                    height: 34px;
                    // background: #EBF3FF;
                    border-radius: 17px;
                    margin-right: 13px;
                    overflow: hidden;
                    img{
                        width: 100%;
                        height: 100%;

                    }
                }
            }

            .fahuo {
                margin-top: 34px;
                width: 100%;
                border-top: 1px solid #F1F2F4;
                height: 51px;
                padding-top: 20px;

                .overandfahuo {
                    display: flex;
                    align-items: center;
                    float: right;

                    .over {
                        width: 124px;
                        height: 51px;
                        background: #FFFFFF;
                        border: 1px solid #3686FF;
                        color: #3686FF;
                        border-radius: 8px;
                        text-align: center;
                        line-height: 51px;
                        cursor: pointer;

                    }

                    .now {
                        width: 124px;
                        height: 51px;
                        background: #FFFFFF;
                        border: 1px solid #3686FF;
                        background: #3686FF;
                        color: #FFFFFF;
                        line-height: 51px;
                        text-align: center;
                        border-radius: 8px;
                        margin-left: 17px;
                        cursor: pointer;
                    }

                }
            }

            .orderstore {
                width: 100%;
                height: 92px;
                background: #FAFAFA;
                border-radius: 8px;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px 0 18px;
                box-sizing: border-box;

                .orderhead {
                    width: calc(100% - 100px);
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;

                    .orderheads {
                        width: 60px;
                        height: 60px;
                        border-radius: 8px;
                        background: #cfd3da;
                        margin-right: 16px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .ordername {
                        display: flex;
                        width: calc(100% - 80px);

                        flex-direction: column;
                        justify-content: space-between;
                        height: 55px;
                        font-size: 18px;
                        color: #111827;

                        .ordernames {
                            // width: 300px; 
                            width: 70%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .jianjie {
                            width: 70%;

                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                        }
                    }

                }

                .ordernuber {


                    .nmber {
                        height: 55px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-size: 18px;
                        color: #111827;

                        .jianjie {
                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                            text-align: right;
                            white-space: nowrap;

                            overflow: hidden;

                            text-overflow: ellipsis;
                        }
                    }

                }
            }
        }

        .orderstated {
            margin-top: 24px;
            width: 100%;
            height: calc(100% - 373px);
            background-color: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 0 34px;

            .ordertext {
                height: 82px;
                border-bottom: 1px solid #F1F2F4;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-family: AppleSystemUIFont;
                color: #3686FF;

                .orderimg {
                    width: 34px;
                    height: 34px;
                    // background: #EBF3FF;
                    border-radius: 17px;
                    margin-right: 13px;
                    overflow: hidden;
                    img{
                        width: 100%;
                        height: 100%;

                    }
                }
            }

            .xiaoji {
                border-bottom: 1px solid #F1F2F4;
                padding-bottom: 16px;

                .xiaojis {
                    display: flex;
                    justify-content: space-between;
                    font-size: 18px;
                    font-weight: 400;
                    color: #718096;
                    margin-top: 24px;

                    .xiaoname {
                        display: flex;

                        .xiao {
                            width: 72px;
                            margin-right: 25px;
                        }
                    }
                }


            }

            .yifu {
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
            }

        }
    }

    .Buyer {
        width: 396px;
        height: 100%;
        margin-left: 26px;

        .bMessages {
            width: 100%;
            height: 372px;
            background-color: #fff;
            border-radius: 8px;
            padding: 29px 30px 0 34px;
            box-sizing: border-box;

            .maihead {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;

                .header {
                    height: 52px;
                    width: 328px;
                    display: flex;

                    .hea {
                        width: 52px;
                        height: 52px;
                        background-color: #cfd3da;
                        border-radius: 26px;
                        overflow: hidden;
                    }

                    .hname {
                        margin-left: 20px;
                        font-size: 18px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        .memngl {
                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                        }
                    }
                }
            }

            .hname {
                height: 52px;
                margin-left: 20px;
                font-size: 18px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                .memngl {
                    font-size: 14px;
                    font-weight: 400;
                    color: #718096;
                }
            }


        }

        .bian {
            width: 100%;
            height: calc(100% - 387px);
            min-height: 340px;
            background-color: #fff;
            margin-top: 15px;
            border-radius: 8px;
            padding: 29px 0 0 34px;
            box-sizing: border-box;

            .hname {
                height: 62px;
                margin-left: 20px;
                font-size: 16px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .memngl {
                    font-size: 14px;
                    font-weight: 400;
                    color: #A0AEC0;
                }
            }
        }

    }
}

.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}
</style>